/* eslint-disable jsx-a11y/click-events-have-key-events */
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';
import { ANSWER_TYPE } from '../../constants';
import './style.scss';

const Answer = ({ id, type, questionId, checked, value, className, handleChange }) => {
  const types = {
    SINGLE: 'radio',
    MULTIPLE: 'checkbox'
  };

  const handleSelectAnswer = () => {
    handleChange(id);
  };

  return (
    <>
      <Form.Check
        type={types[type]}
        className={`${className} answer ${checked ? 'checked' : ''}`}
        defaultChecked={checked}
        id={`${questionId}-${id}`}
        name={`answer-${questionId}`}
        onChange={handleSelectAnswer}
        label={value}
      />

    </>
  );
};

Answer.propTypes = {
  type: PropTypes.oneOf([ANSWER_TYPE.SINGLE, ANSWER_TYPE.MULTIPLE]).isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  handleChange: PropTypes.func,
  checked: PropTypes.bool.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  questionId: PropTypes.number
};

Answer.defaultProps = {
  className: '',
  handleChange: () => {},
  questionId: 0
};

export default Answer;
